var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"screenshots"},_vm._l((_vm.images),function(image,key){return _c('a',{key:key,staticClass:"screenshot",on:{"click":function($event){return _vm.zoomImage(key)}}},[_c('img',{attrs:{"src":image}})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }